import React from 'react';
import PropTypes from 'prop-types';
import {ThemeContext} from '../../common';
import treasureImg from '../../../images/treasure.png';
import {getResizeImagePaths, onImageError} from '../../../utils';

const TreasureChestItem = (props) => {
  const {
    asset,
    goldCoins,
    name,
    onTreasureSelect,
  } = props;
  const {url = treasureImg, title} = asset || {};

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const styles = {
          color: theme.secondaryColor,
        };
        const {defaultImageURL, resizedImageURL} = getResizeImagePaths(url, 100);

        return (
          <figure className="treasure">
            <div
              className="treasure__image-wrap row row_vcenter row_center"
              onClick={onTreasureSelect}
            >
              <img
                className="treasure__image"
                src={resizedImageURL}
                onError={onImageError(defaultImageURL)}
                alt={title}
                title={title}
              />
            </div>
            <figcaption className="treasure__name">{name}</figcaption>
            <div className="treasure__points" style={styles}>
              YakGold&nbsp;
              <b>{goldCoins}</b>
            </div>
          </figure>
        );
      }}
    </ThemeContext.Consumer>
  );
};

TreasureChestItem.propTypes = {
  asset: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
  }),
  goldCoins: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  onTreasureSelect: PropTypes.func.isRequired,
};

TreasureChestItem.defaultProps = {
  asset: null,
};

export default TreasureChestItem;
